<app-dispatch-operations-report
  *ngIf="showReportPreview"
  (closeReport)="showReportPreview = false"
></app-dispatch-operations-report>

<div
  class="dispatch-component"
  *ngIf="!showReportPreview"
>
  <div
    class="p-grid main-wrapper"
    cdkDropListGroup
  >
    <div class="p-grid main-wrapper">
    <!-- Dispatch-specific gear menu, toggled from the shared controls bar
         (registered onGear handler). The section-title topbar it used to
         sit in was removed as pure whitespace (Ray); the autosave pill
         moved above the asset cards — see board-save-note below. -->
          <p-overlayPanel #gearMenu>
            <div class="gear-menu">
              <a class="gear-menu-item" (click)="addReserveBlock(); gearMenu.hide()">
                <i class="pi pi-flag"></i> Add Reserve Block
              </a>
              <a class="gear-menu-item" (click)="addAdminBlock(); gearMenu.hide()">
                <i class="pi pi-clock"></i> Add Admin Time
              </a>
              <a class="gear-menu-item" (click)="addOpsManagerBlock(); gearMenu.hide()">
                <i class="pi pi-user-plus"></i> Add Ops Manager
              </a>
              <a class="gear-menu-item" (click)="addOpsTask(); gearMenu.hide()">
                <i class="pi pi-check-square"></i> Add OPS Task
              </a>
              <a class="gear-menu-item" (click)="resetDefaultBlocks(); gearMenu.hide()">
                <i class="pi pi-replay"></i> Reset Default Blocks
              </a>
              <p-divider styleClass="gear-menu-divider"></p-divider>
          <div class="gear-menu-item gear-toggle">
            <p-toggleButton
              [ngModel]="(autosaveEnabled$ | async) ?? true"
              (ngModelChange)="toggleAutosave($event)"
              onLabel="Autosave"
              offLabel="Autosave"
              [style]="{ width: '100%' }"
            />
            <small class="gear-hint" *ngIf="(autosaveEnabled$ | async) === false && (autosaveDisabledReason$ | async)">
              Save failed — autosave disabled.
            </small>
          </div>
          <p-divider styleClass="gear-menu-divider"></p-divider>
              <a
                class="gear-menu-item"
                *ngIf="canViewCalendarRemarks$ | async"
                (click)="openCalendarRemarksDialog(); gearMenu.hide()"
              >
                <i class="pi pi-comment"></i> Calendar Remarks
              </a>
            </div>
          </p-overlayPanel>
      <main class="p-col-12 p-grid">
        <div
          class="p-col-12 p-sm-6 p-md-6 p-lg-6 p-xl-3 desktop-separator"
          *ngIf="sidebarVisible"
        >
          <app-dispatch-crew></app-dispatch-crew>
        </div>
        <div
          class="p-col-12 p-sm-6 p-md-6 p-lg-6"
          [ngClass]="{ 'p-xl-9': sidebarVisible, 'p-xl-12': !sidebarVisible }"
        >
          <!-- Save-state pill (Ray): moved here to the board wrapper's top
               right, above the asset cards. The old section-title topbar row
               (empty header + reserved autosave slot) was pure whitespace
               between the tabs and the tool and is gone. Always visible:
               Saving... / Unsaved changes (n) — saving in Ns / Unsaved —
               autosave off / idle "All changes are saved". Click expands
               Discard/Save when changes are pending. -->
          <div class="board-save-note">
            <div
              class="dispatch-unsaved-banner"
              [ngClass]="{ 'is-saving': isSavingChanges$ | async, 'is-collapsed': !bannerExpanded && (isSavingChanges$ | async) === false }"
              (click)="bannerExpanded = true"
            >
            <ng-container *ngIf="isSavingChanges$ | async; else collapsedIndicator">
              <div class="banner-left">
                <i class="pi pi-spin pi-spinner"></i>
                <span>Saving...</span>
              </div>
            </ng-container>
            <ng-template #collapsedIndicator>
              <!-- !bannerExpanded: collapsed normal state. || !pending: once
                   autosave drains the queue the expanded branch (which
                   requires pending changes) can no longer render, so fall
                   through to the collapsed branch to keep the save status
                   ("All changes are saved") visible. -->
              <ng-container *ngIf="!bannerExpanded || (hasPendingChanges$ | async) === false">
                <div class="banner-left">
                  @if (autosaveCountdown$ | async; as countdown) {
                    <i class="pi pi-clock"></i>
                    <span>
                      Unsaved changes ({{ pendingChangeCount$ | async }}) —
                      saving in {{ countdown }}s
                    </span>
                  } @else if ((hasPendingChanges$ | async)) {
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>Unsaved changes ({{ pendingChangeCount$ | async }}) — autosave off</span>
                  } @else if ((autosaveEnabled$ | async) === false) {
                    <i class="pi pi-exclamation-triangle autosave-off-icon"></i>
                    <span>Autosave off</span>
                  } @else {
                    <i class="pi pi-check-circle"></i>
                    <span>All changes are saved</span>
                  }
                </div>
              </ng-container>
              <ng-container *ngIf="bannerExpanded && (hasPendingChanges$ | async)">
                <div class="banner-left">
                  <i class="pi pi-exclamation-triangle"></i>
                  <span>Unsaved changes ({{ pendingChangeCount$ | async }})</span>
                </div>
                <div class="banner-buttons">
                  <button
                    pButton
                    class="p-button-text p-m-1 banner-btn"
                    label="Discard"
                    [disabled]="isSavingChanges$ | async"
                    (click)="store.dispatch(DispatchActions.discardChangesClicked()); bannerExpanded = false"
                  ></button>
                  <button
                    pButton
                    class="p-button-text p-m-1 banner-btn"
                    label="Save"
                    [disabled]="isSavingChanges$ | async"
                    (click)="store.dispatch(DispatchActions.saveChangesClicked()); bannerExpanded = false"
                  ></button>
                </div>
              </ng-container>
            </ng-template>
            </div>
          </div>

          <!-- Calendar remarks for the viewed date (Ray: show on dispatch too) -->
          <ng-container *ngIf="calendarRemark$ | async as remarks">
            <div
              class="calendar-remark-banner"
              *ngFor="let remark of remarks"
              [ngClass]="'severity-' + remark.severity"
            >
              <i class="pi pi-comment"></i>
              <span class="calendar-remark-text">{{ remark.text }}</span>
            </div>
          </ng-container>
          <ng-container *ngIf="conflictingEvents$ | async as conflictingEvents">
            <div
              class="conflicting-events-message"
              *ngIf="conflictingEvents.length"
            >
              There are {{ conflictingEvents.length }} events with scheduling
              conflicts:
              <b
                *ngFor="
                let conflictingEvent of conflictingEvents;
                let last = last
                "
                (click)="scrollToEvent(conflictingEvent.event.id)"
              >
                {{ conflictingEvent.customer.name === 'No customer set' ? conflictingEvent.event.title : conflictingEvent.customer.name }}

                @if (conflictingEvent?.event?.job?.code){
                <small>({{ conflictingEvent.event.job.code }})</small>
                }

                <ng-container *ngIf="!last">, </ng-container>
              </b>
            </div>
          </ng-container>

          <div
            class="p-mt-4 dispatch-table"
            *ngIf="eventsLoaded; else loading"
          >
            <ng-container *ngIf="events?.length; else noEvents">
              <!-- Divider between the admin blocks (ops manager / reserve /
                   admin / ops tasks) and the actual moves below them:
                   rendered inside the loop right before the group card that
                   follows the last admin block. -->
              <ng-container *ngFor="let group of events; let i = index; trackBy: trackByGroupId">
                <hr
                  class="route-section-divider"
                  *ngIf="group.isSpecial && events[i + 1] && !events[i + 1].isSpecial"
                />
                <div class="route-table">
                <!-- Row 1: Route name + metrics -->
                <div class="route-header-row">
                  <div class="route-name">
                    <i
                      *ngIf="group.isSpecial"
                      class="pi"
                      [ngClass]="{
                        'pi-user-plus': group.groupLabel.startsWith('Ops Manager'),
                        'pi-flag': group.groupLabel.startsWith('Reserve'),
                        'pi-clock': group.groupLabel.startsWith('Admin') || group.groupLabel.startsWith('Non-Billable'),
                        'pi-check-square': group.isOpsTask
                      }"
                    ></i>
                    <i *ngIf="!group.isSpecial" class="pi pi-truck"></i>
                    <a
                      class="route-label"
                      (click)="group.isSpecial ? openTimePopup(group) : openAssetInRightPanel(group)"
                    >{{ group.groupLabel }}</a>
                  </div>
                  <div class="route-time" *ngIf="group.isSpecial && group.startTime">
                    <span
                      class="metric-cost"
                      *ngIf="group.totalLaborCost"
                      pTooltip="Labor cost for this block"
                      tooltipPosition="bottom"
                    >{{ group.totalLaborCost | freyaCurrency: group.currency }}</span>
                    <a (click)="openTimePopup(group)">{{ group.startTime }} - {{ group.endTime }}</a>
                    <span class="special-crew-req" *ngIf="getSpecialCrewReqText(group)">
                      {{ getSpecialCrewReqText(group) }}
                    </span>
                    <i
                      *ngIf="!getRouteCrewCount(group)"
                      class="pi pi-trash route-delete-btn"
                      (click)="deleteBlock(group)"
                      pTooltip="Delete block"
                      tooltipPosition="bottom"
                    ></i>
                  </div>
                  <div class="route-metrics" *ngIf="!group.isSpecial">
                    <span class="metric-revenue">
                      {{ group.totalRevenue | freyaCurrency: group.currency }}
                    </span>
                    <span class="metric-cost">
                      {{ group.totalLaborCost | freyaCurrency: group.currency }}
                    </span>
                    <span class="metric-labor-pct">({{ group.laborPercentage }}%)</span>
                    <!-- Total time for the day (min start → max end). Not
                         clickable — future clock-in/out hooks live here. -->
                    <span
                      class="metric-total-time"
                      *ngIf="group.startTime"
                      pTooltip="Earliest start → latest end on this route"
                      tooltipPosition="bottom"
                    >{{ group.startTime }} - {{ group.endTime }}</span>
                  </div>
                </div>

                <!-- Row 2: Table layout — crew (left, fills) + events (middle, wraps) + ops summary (right, fills height) -->
                <div class="route-body-row">
                  <!-- Left: Crew drop zone (fills available width) -->
                  <div
                    class="route-crew-col"
                    cdkDropList
                    [cdkDropListData]="group"
                    (cdkDropListDropped)="onRouteDrop($event)"
                  >
                    <div
                      *ngFor="let member of group.crew"
                      class="crew-chip-wrapper"
                      cdkDrag
                      [cdkDragData]="member.dragData"
                      (contextmenu)="onCrewRightClick($event, member, { type: 'route', group })"
                    >
                      <app-dispatch-chip
                        [name]="member.name"
                        [showStar]="member.isCrewLead"
                        [isDriver]="member.isDriver"
                        [isAssigned]="true"
                        [removable]="true"
                        [hasConflict]="member.hasConflict"
                        [events]="events"
                        [conflictingEventIds]="member.conflictingEventIds"
                        [tooltipText]="member.tooltip"
                        [rateHourly]="member.rateHourly"
                        [totalCost]="member.totalCost"
                        [overtimeHours]="member.overtimeHours"
                        [hoursWorkedThisWeek]="member.hoursWorkedThisWeek"
                        [availability]="member.availability"
                        (edit)="onCrewChipEdit(member)"
                        (remove)="onRemoveCrewFromRoute(group, member)"
                        panelType="right"
                      ></app-dispatch-chip>
                    </div>

                    <span
                      class="placeholder-text"
                      *ngIf="!group.crew?.length"
                    >Drag crew here</span>
                  </div>

                  <!-- Middle: Ops-manager day notes (Ray: "tell them what to do on
                       that day") — rich text on the ops-manager event's metadata -->
                  <div
                    *ngIf="group.isSpecial && group.groupLabel.startsWith('Ops Manager') && group.events?.length"
                    class="route-events-col"
                  >
                    <div class="day-notes-quill">
                      <quill-editor
                        format="object"
                        [ngModel]="getDayNotesDelta(group.events[0])"
                        (ngModelChange)="onDayNotesContentChanged(group.events[0], $event)"
                        [modules]="dayNotesQuillModules"
                        [placeholder]="'Day notes for the ops manager (instructions, priorities)...'"
                        [compareValues]="true"
                      ></quill-editor>
                    </div>
                  </div>

                  <!-- Middle: Event cards (wrap to next row) — hidden for special crew-drop rows -->
                  <div class="route-events-col" *ngIf="group.events?.length && (!group.isSpecial || group.isOpsTask)">
                    <!-- OPS task cards (Ray's OPS section) -->
                    <ng-container *ngIf="group.isOpsTask; else jobCards">
                      <div
                        *ngFor="let event of group.events; trackBy: trackByEventId"
                        class="ops-task-card"
                        [ngClass]="{ 'is-completed': isOpsTaskCompleted(event) }"
                        [id]="'event-' + event.event.id"
                      >
                        <div class="ops-task-main">
                          <div class="ops-task-head">
                            <p-button
                              [icon]="isOpsTaskCompleted(event) ? 'pi pi-check-circle' : 'pi pi-circle'"
                              [text]="true"
                              size="small"
                              (onClick)="toggleOpsTaskCompleted(event)"
                              pTooltip="{{ isOpsTaskCompleted(event) ? 'Completed — click to reopen' : 'Mark completed' }}"
                              tooltipPosition="bottom"
                            ></p-button>
                            <span class="ops-task-title">{{ event.event.title }}</span>
                            <span
                              class="ops-task-cost metric-cost"
                              *ngIf="event.totalLaborCost"
                              pTooltip="Labor cost for this task"
                              tooltipPosition="bottom"
                            >{{ event.totalLaborCost | freyaCurrency: event.event.job?.currency || 'USD' }}</span>
                            <span class="ops-task-time">{{ event.startTime }} - {{ event.endTime }}</span>
                            <span
                              class="ops-task-menu-btn"
                              (click)="opsTaskMenuOp.toggle($event); opsTaskMenuEvent = event"
                            ><i class="pi pi-ellipsis-v"></i></span>
                            <p-overlayPanel #opsTaskMenuOp styleClass="mini-menu-panel">
                              <div class="mini-menu" *ngIf="opsTaskMenuEvent">
                                <a class="mini-menu-item" (click)="openOpsTaskDialog(group, opsTaskMenuEvent); opsTaskMenuOp.hide()">
                                  <i class="pi pi-pencil"></i> Edit Task
                                </a>
                                <a class="mini-menu-item" (click)="toggleOpsTaskCompleted(opsTaskMenuEvent); opsTaskMenuOp.hide()">
                                  <i class="pi" [ngClass]="isOpsTaskCompleted(opsTaskMenuEvent) ? 'pi-replay' : 'pi-check-circle'"></i>
                                  {{ isOpsTaskCompleted(opsTaskMenuEvent) ? 'Mark Not Completed' : 'Mark Completed' }}
                                </a>
                                <a class="mini-menu-item" (click)="deleteBlock(group); opsTaskMenuOp.hide()">
                                  <i class="pi pi-trash"></i> Delete Task
                                </a>
                              </div>
                            </p-overlayPanel>
                          </div>
                          <!-- Associated job + crew above the notes (match job cards) -->
                          <div class="ops-task-meta">
                            <a
                              *ngIf="getOpsTaskMeta(event)?.jobCode"
                              class="ops-task-job-link"
                              (click)="openAssociatedJob(event)"
                            ><i class="pi pi-briefcase"></i> {{ getOpsTaskMeta(event).jobCode }}</a>
                          </div>
                          <div
                            class="mini-event-crew"
                            cdkDropList
                            [cdkDropListData]="event"
                            [cdkDropListEnterPredicate]="attendeesOnlyDragPredicate"
                            (cdkDropListDropped)="onEventDrop($event, event)"
                          >
                            <!-- D-2/D-5 (Maria): label the crew drop zone. -->
                            <span class="crew-zone-label" *ngIf="event.eventOnlyCrew?.length">
                              <i class="pi pi-users"></i>
                              Crew {{ event.eventOnlyCrew.length }}
                            </span>
                            <div
                              *ngFor="let member of event.eventOnlyCrew"
                              class="crew-chip-wrapper"
                              cdkDrag
                              [cdkDragData]="member.dragData"
                              (contextmenu)="onCrewRightClick($event, member, { type: 'event', event })"
                            >
                              <app-dispatch-chip
                                [name]="member.name"
                                [showStar]="member.isCrewLead"
                                [isDriver]="member.isDriver"
                                [isAssigned]="true"
                                [removable]="true"
                                [hasConflict]="member.hasConflict"
                                [events]="events"
                                [conflictingEventIds]="member.conflictingEventIds"
                                [tooltipText]="member.tooltip"
                                [rateHourly]="member.rateHourly"
                                [totalCost]="member.totalCost"
                                [overtimeHours]="member.overtimeHours"
                                [hoursWorkedThisWeek]="member.hoursWorkedThisWeek"
                                [availability]="member.availability"
                                (edit)="onCrewChipEdit(member)"
                                (remove)="onRemoveCrewFromEvent(event, member)"
                                panelType="right"
                              ></app-dispatch-chip>
                              <!-- #7283 D: the crew member's personal note
                                   inline — typed in the send dialog shows
                                   immediately; after send, the backend-stamped
                                   event note persists across reloads. -->
                              <span
                                class="crew-personal-note-inline"
                                *ngIf="getInlineCrewPersonalNote(event, member.userId) as note"
                                [pTooltip]="'Personal note: ' + note"
                                tooltipPosition="top"
                              >{{ note }}</span>
                            </div>
                            <span class="mini-crew-placeholder" *ngIf="!event.eventOnlyCrew?.length">Drag crew here</span>
                            <!-- #7283 D (CodeRabbit round 2): shared route crew
                                 aren't in eventOnlyCrew, but their notes for
                                 THIS event still belong on its card. -->
                            <span
                              class="crew-personal-note-inline shared-crew-note"
                              *ngFor="let line of getSharedCrewNoteLines(group, event); trackBy: trackBySharedNoteLine"
                              [pTooltip]="'Personal note: ' + line.note"
                              tooltipPosition="top"
                            ><i class="pi pi-users"></i> {{ line.name }}: {{ line.note }}</span>
                          </div>
                          <div class="ops-task-crew-notes crew-notes-quill">
                            <!-- #7283 C: collapse persists per user (browser-local);
                                 unstored sections default to expanded. -->
                            <button
                              type="button"
                              class="notes-collapse-toggle"
                              (click)="toggleEventNotes(event.event.id)"
                              [attr.aria-expanded]="isEventNotesExpanded(event.event.id)"
                            >
                              <i class="pi"
                                 [ngClass]="isEventNotesExpanded(event.event.id) ? 'pi-chevron-down' : 'pi-chevron-right'"
                              ></i>
                              <span class="toggle-label">Event notes</span>
                            </button>
                            <ng-container *ngIf="isEventNotesExpanded(event.event.id)">
                            <quill-editor
                              format="object"
                              [ngModel]="getCrewNotesDelta(event)"
                              (ngModelChange)="onCrewNotesContentChanged(event, $event)"
                              [modules]="crewNotesQuillModules"
                              [placeholder]="'Notes for the crew (sent to crew)...'"
                              [compareValues]="true"
                              [id]="'ops-task-notes-' + event.event.id"
                            ></quill-editor>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #jobCards>
                    <div
                      *ngFor="let event of group.events; trackBy: trackByEventId"
                      class="mini-event-card"
                      [id]="'event-' + event.event.id"
                      [ngClass]="{ 'has-conflict': event.eventHasConflict }"
                    >
                      <!-- D-3 (Maria): the time is the primary scan item on the
                           card — first and prominent (time → event name →
                           truck → crew). -->
                      <div class="mini-card-time">
                        <span class="mini-time">{{ event.startTime }} - {{ event.endTime }}</span>
                      </div>
                      <div class="mini-card-info">
                        <div class="mini-card-top-row">
                          <div class="mini-card-name-code">
                            <a class="mini-event-title" (click)="openJobInRightPanel(event)">{{ event.event.title }}</a>
                            <a
                              class="mini-customer-name"
                              (click)="openJobInRightPanel(event)"
                            >{{ event.customer.name }}</a>
                            <a
                              *ngIf="event.event.job?.code"
                              class="mini-job-code"
                              (click)="openJobInRightPanel(event)"
                            >({{ event.event.job.code }})</a>
                            <!-- Additional contacts (Ray: show on dispatch) -->
                            <div class="mini-contact-chips" *ngIf="getAdditionalContacts(event).length">
                              <span
                                class="mini-contact-chip"
                                *ngFor="let contact of getAdditionalContacts(event)"
                                [pTooltip]="contactTooltip(contact)"
                                tooltipPosition="top"
                              >
                                <i class="pi pi-user"></i>
                                {{ contact.name }}<span *ngIf="contact.relationship"> ({{ contact.relationship }})</span>
                              </span>
                            </div>
                          </div>
                          <div class="mini-card-actions">
                            <p-button
                              icon="pi pi-ellipsis-v"
                              text="true"
                              size="small"
                              (onClick)="miniMenuOp.toggle($event)"
                            ></p-button>
                            <p-overlayPanel #miniMenuOp>
                              <div class="mini-menu">
                                <a class="mini-menu-item" (click)="openEditDispatchEventDialog(event); miniMenuOp.hide()">
                                  <i class="pi pi-users"></i> Manage Crew and Trucks
                                </a>
                                <a class="mini-menu-item" (click)="clearCrewForEvent(event); miniMenuOp.hide()">
                                  <i class="pi pi-user-minus"></i> Clear Crew
                                </a>
                                <a class="mini-menu-item" (click)="openJobInRightPanel(event); miniMenuOp.hide()">
                                  <i class="pi pi-pencil"></i> Edit Job
                                </a>
                                <a class="mini-menu-item" (click)="openEventDetails(event); miniMenuOp.hide()">
                                  <i class="pi pi-info-circle"></i> Event Details
                                </a>
                                <a class="mini-menu-item" (click)="printBol(event); miniMenuOp.hide()">
                                  <i class="pi pi-print"></i> Print BOL
                                </a>
                              </div>
                            </p-overlayPanel>
                          </div>
                        </div>
                        <!-- Trucks + delivery route under the order (Ray: the
                             route immediately visible, followed by the trucks;
                             reuses the board's existing route/asset grouping —
                             group.group is the route's truck, event.trucks the
                             event's resolved assets). -->
                        <div class="mini-card-trucks" *ngIf="event.trucks?.length || (activeGroupBy === DispatchGroupOptions.Route && group.group)">
                          <!-- Route grouping only: the group key would be a
                               start time or status in those modes (CodeRabbit). -->
                          <p-chip
                            *ngIf="activeGroupBy === DispatchGroupOptions.Route && group.group"
                            icon="pi pi-map-marker"
                            [label]="group.groupLabel"
                            styleClass="mini-chip mini-route-chip"
                          />
                          <app-dispatch-chip
                            *ngFor="let truck of event.trucks"
                            [name]="truck.name"
                            [hasConflict]="truck.hasConflict"
                            icon="pi pi-truck"
                          ></app-dispatch-chip>
                        </div>
                        <!-- Live crew navigator status (Ray: live status on dispatch) -->
                        <app-navigator-status
                          *ngIf="event.event.navigatorCurrentStep && event.event.navigatorCurrentStep !== 'started'"
                          [eventId]="event.event.id"
                          [navigatorCurrentStep]="event.event.navigatorCurrentStep"
                          [navigatorData]="event.event.navigatorData"
                        ></app-navigator-status>
                        <div class="mini-card-tags">
                          <p-chip
                            [style]="event.style"
                            label="{{ event.event.type | titlecase }}"
                            styleClass="mini-chip"
                          />
                          <p-chip
                            label="{{ event.event.status | titlecase }}"
                            styleClass="mini-chip"
                          />
                        </div>
                        <div class="mini-card-requirements">
                          <!-- D-5: crew status lives in the drop zone now; the
                               header keeps only the truck warning (Maria). -->
                          <span *ngIf="!event.trucks.length" class="mini-warning">
                            <i class="pi pi-exclamation-triangle"></i> Needs truck
                          </span>
                          <span *ngIf="event.eventHasConflict" class="mini-warning">
                            <i class="pi pi-exclamation-triangle"></i> Conflict
                          </span>
                          <span class="mini-total" *ngIf="event.event.discountedSubTotal">
                            {{ event.event.discountedSubTotal | freyaCurrency: event.event.job?.currency || 'USD' }}
                          </span>
                        </div>
                        <!-- Per-event crew (not shared across all route events).
                             D-2/D-5 (Maria): the zone is labelled with the crew
                             status so the dashed hover affordance reads as the
                             crew drop area. -->
                        <div
                          class="mini-event-crew"
                          cdkDropList
                          [cdkDropListData]="event"
                          [cdkDropListEnterPredicate]="attendeesOnlyDragPredicate"
                          (cdkDropListDropped)="onEventDrop($event, event)"
                        >
                          <span class="crew-zone-label" *ngIf="event.crew.length || event.crewRequirement">
                            <i class="pi pi-users"></i>
                            Crew {{ event.crew.length }}/{{ event.crewRequirement }}
                            <!-- Consistent with the route-column placeholder: every
                                 crew slot that isn't full carries the same drag
                                 affordance inline — no extra width, the hint shares
                                 the label line. The "Needs crew" words drop to the
                                 warning icon's tooltip (same info, less text). -->
                            <span *ngIf="event.needsMoreCrew" class="mini-warning"
                                  pTooltip="Needs crew" tooltipPosition="top"
                            >
                              <i class="pi pi-exclamation-triangle"></i>
                            </span>
                            <span *ngIf="event.needsMoreCrew" class="mini-crew-placeholder">Drag crew here</span>
                          </span>
                          <!-- No crew and no requirement: previously this zone
                               rendered completely blank (no label, chips or
                               placeholder), so half the board had no visible
                               drop affordance at all. -->
                          <span class="mini-crew-placeholder"
                                *ngIf="!event.crew.length && !event.crewRequirement"
                          >Drag crew here</span>
                          <div
                            *ngFor="let member of event.eventOnlyCrew"
                            class="crew-chip-wrapper"
                            cdkDrag
                            [cdkDragData]="member.dragData"
                            (contextmenu)="onCrewRightClick($event, member, { type: 'event', event })"
                          >
                            <!-- Personal note received with the crew member's
                                 schedule send (persisted by the backend at
                                 send time — Ray #6983: visible on Dispatch,
                                 not only in the send dialog). -->
                            <ng-container *ngIf="getCrewPersonalNote(event, member.userId) as personalNote">
                              <!-- A button, not a span (CodeRabbit): focusable,
                                   so the tooltip opens from the keyboard on
                                   focus, and the aria-label carries the note
                                   text itself, not just a hint that one exists. -->
                              <button
                                type="button"
                                class="crew-personal-note-badge"
                                [pTooltip]="'Personal note sent: ' + personalNote.note"
                                tooltipPosition="top"
                                [attr.aria-label]="'Personal note sent to ' + member.name + ': ' + personalNote.note"
                              >
                                <i class="pi pi-comment" aria-hidden="true"></i>
                              </button>
                            </ng-container>
                            <app-dispatch-chip
                              [name]="member.name"
                              [showStar]="member.isCrewLead"
                              [isDriver]="member.isDriver"
                              [isAssigned]="true"
                              [removable]="true"
                              [hasConflict]="member.hasConflict"
                              [events]="events"
                              [conflictingEventIds]="member.conflictingEventIds"
                              [tooltipText]="member.tooltip"
                              [rateHourly]="member.rateHourly"
                              [totalCost]="member.totalCost"
                              [overtimeHours]="member.overtimeHours"
                              [hoursWorkedThisWeek]="member.hoursWorkedThisWeek"
                              [availability]="member.availability"
                              (edit)="onCrewChipEdit(member)"
                              (remove)="onRemoveCrewFromEvent(event, member)"
                              panelType="right"
                            ></app-dispatch-chip>
                            <!-- #7283 D: same inline personal note as the
                                 ops-task cards (dialog-typed shows
                                 immediately; event-stamped persists). -->
                            <span
                              class="crew-personal-note-inline"
                              *ngIf="getInlineCrewPersonalNote(event, member.userId) as note"
                              [pTooltip]="'Personal note: ' + note"
                              tooltipPosition="top"
                            >{{ note }}</span>
                          </div>
                          <!-- #7283 D (CodeRabbit round 2): shared route crew
                               aren't chip'd on the event card — their per-event
                               notes for THIS event render here, OUTSIDE the
                               event-only crew loop (inside would repeat per
                               member and vanish on an empty loop). -->
                          <span
                            class="crew-personal-note-inline shared-crew-note"
                            *ngFor="let line of getSharedCrewNoteLines(group, event); trackBy: trackBySharedNoteLine"
                            [pTooltip]="'Personal note: ' + line.note"
                            tooltipPosition="top"
                          ><i class="pi pi-users"></i> {{ line.name }}: {{ line.note }}</span>
                        </div>
                      </div>
                      <!-- Bottom: Ops summary (internal — OPS + Sales only) -->
                      <div class="mini-card-ops-notes">
                        <span class="float-label-field" [class.filled]="!!getOpsNotes(event)">
                          <span class="float-label">Ops summary</span>
                          <textarea
                            #opsNotesTa
                            pInputText
                            class="ops-notes-input"
                            [attr.data-event-id]="event.event.id"
                            [value]="getOpsNotes(event)"
                            (input)="onOpsNotesInput(event, $event, opsNotesTa)"
                            (focus)="onOpsNotesFocus(event, opsNotesTa)"
                            [id]="'ops-notes-' + event.event.id"
                            placeholder=" "
                          ></textarea>
                        </span>
                      </div>
                      <!-- Right: Event notes (per-event, crew-visible, emailed) fills
                           height of the card. Same store as the workorders page's
                           Event Notes section (event metadata.eventNotes). -->
                      <div class="mini-card-crew-notes crew-notes-quill">
                        <!-- #7283 C: collapse persists per user (browser-local);
                             unstored sections default to expanded (current behavior). -->
                        <button
                          type="button"
                          class="notes-collapse-toggle"
                          (click)="toggleEventNotes(event.event.id)"
                          [attr.aria-expanded]="isEventNotesExpanded(event.event.id)"
                        >
                          <i class="pi"
                             [ngClass]="isEventNotesExpanded(event.event.id) ? 'pi-chevron-down' : 'pi-chevron-right'"
                          ></i>
                          <span class="toggle-label">Event notes</span>
                          <span class="toggle-hint">visible to crew — not the customer</span>
                        </button>
                        <ng-container *ngIf="isEventNotesExpanded(event.event.id)">
                        <span class="static-label-field quill-field">
                          <quill-editor
                            format="object"
                            [ngModel]="getCrewNotesDelta(event)"
                            (ngModelChange)="onCrewNotesContentChanged(event, $event)"
                            [modules]="crewNotesQuillModules"
                            [placeholder]="' '"
                            [compareValues]="true"
                            [id]="'crew-notes-' + event.event.id"
                            (onEditorCreated)="onCrewNotesEditorCreated($event, event)"
                          ></quill-editor>
                        </span>
                        <!-- Attachments (Ray: 📎 inside the Event Notes tools,
                        <!-- Ray: 📎 inside the Event Notes tools, event-scoped
                             — #6983. The chip opens the file; the remove control
                             is a sibling button (no interactive nesting inside
                             the chip, keyboard-reachable, labelled). -->
                        <div class="mini-card-attachments" *ngIf="getEventNotesAttachments(event).length">
                          <span class="event-attachment-chip-wrap" *ngFor="let attachment of getEventNotesAttachments(event)">
                            <button
                              type="button"
                              class="event-attachment-chip"
                              (click)="openEventNotesAttachment(attachment)"
                            >
                              <i class="pi pi-paperclip"></i>
                              <span class="file-name">{{ attachment.name }}</span>
                            </button>
                            <button
                              type="button"
                              class="mini-attachment-remove"
                              aria-label="Remove attachment"
                              [pTooltip]="'Remove attachment'"
                              tooltipPosition="bottom"
                              (click)="onRemoveEventNotesAttachment(event, attachment)"
                            >
                              <i class="pi pi-times"></i>
                            </button>
                          </span>
                        </div>
                        </ng-container>
                      </div>
                    </div>
                     </ng-template>
                   </div>
                 </div>
               </div>
              </ng-container>
             </ng-container>
             <ng-template #noEvents>
              <p class="no-events-message">
                No events scheduled for
                {{ filterEventsForm.value.date | date: 'MMM d, yyyy' }}
              </p>
  </ng-template>
</div>

          <ng-template #loading>
            <div class="p-mt-4 dispatch-table">
              <div *ngFor="let i of [0,1,2,3]" class="route-table">
                <div class="route-header-row">
                  <p-skeleton width="120px" height="1rem" />
                  <p-skeleton width="80px" height="0.8rem" />
                </div>
                <div class="route-body-row">
                  <div class="route-crew-col">
                    <p-skeleton width="60px" height="1.5rem" styleClass="p-mr-1" />
                    <p-skeleton width="60px" height="1.5rem" styleClass="p-mr-1" />
                  </div>
                  <div class="route-events-col">
                    <div class="mini-event-card" *ngFor="let j of [0,1]">
                      <div class="mini-card-info">
                        <p-skeleton width="180px" height="0.9rem" />
                        <p-skeleton width="100px" height="0.75rem" />
                        <p-skeleton width="60px" height="0.65rem" />
                      </div>
                      <div class="mini-card-ops-notes">
                        <p-skeleton width="100%" height="60px" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  </ng-template>

        </div>
      </main>
    </div>
  </div>

  <p-contextMenu
    #crewContextMenu
    [model]="crewContextMenuItems"
    appendTo="body"
  ></p-contextMenu>

  <p-dialog
    [modal]="true"
    [(visible)]="visible"
    [closable]="false"
    [draggable]="true"
    [breakpoints]="{ '1024px': '62vw', '510px': '93vw' }"
    [style]="{ width: '35vw' }"
  >
    <ng-template pTemplate="headless">
      <app-dispatch-edit-event
        *ngIf="eventUnderEditting !== null"
        [event]="eventUnderEditting"
        (closeDialog)="closeDialog()"
      ></app-dispatch-edit-event>
    </ng-template>
  </p-dialog>

  <p-dialog
    [modal]="true"
    [visible]="isEditCrewRateDialogOpen$ | async"
    [closable]="true"
    [draggable]="true"
    [dismissableMask]="true"
    (visibleChange)="closeCrewSettingsDialog()"
    [breakpoints]="{ '1024px': '62vw', '510px': '93vw' }"
    [style]="{ width: '50vw', height: '70vh' }"
    styleClass="crew-settings-dialog"
  >

    <ng-template pTemplate="header">
      <div class="crew-settings-header">

        <p-avatar
          [label]="(selectedUserForSalaryEdit$ | async)?.familyName?.charAt(0)?.toUpperCase() || null"
          shape="circle"
          [style]="{
            'background-color': '#c9ffa97d',
          }"
        ></p-avatar>

        <h5>{{ (selectedUserForSalaryEdit$ | async)?.familyName || 'New' }} {{ (selectedUserForSalaryEdit$ |
          async)?.givenName || 'Crew Member' }}</h5>
      </div>
    </ng-template>
    <app-dispatch-crew-settings></app-dispatch-crew-settings>

    <ng-template pTemplate="footer">
      <div class="p-d-flex p-jc-between">
        <p-button
          label="Previous"
          icon="pi pi-chevron-left"
          (onClick)="previousCrewMember()"
          [outlined]="true"
          [disabled]="(filteredCrewCount$ | async) <= 1"
        ></p-button>
        <p-button
          label="Next"
          icon="pi pi-chevron-right"
          iconPos="right"
          (onClick)="nextCrewMember()"
          [outlined]="true"
          [disabled]="(filteredCrewCount$ | async) <= 1"
        ></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- New full-page Send Schedule to Crew dialog -->
  <p-dialog
    [modal]="true"
    [visible]="isSendScheduleDialogOpen$ | async"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '90vw', height: '90vh', 'max-width': '1400px' }"
    styleClass="send-schedule-fullpage-dialog"
    (visibleChange)="$event === false && store.dispatch(DispatchActions.sendScheduleDialogClosed())"
  >
    <ng-template pTemplate="headless">
      <app-dispatch-send-schedule-dialog
        (closeDialog)="store.dispatch(DispatchActions.sendScheduleDialogClosed())"
        style="display:flex;flex-direction:column;height:100%;overflow:hidden"
      ></app-dispatch-send-schedule-dialog>
    </ng-template>
  </p-dialog>

  <!-- Calendar Remarks dialog -->
  <p-dialog
    [modal]="true"
    [visible]="isCalendarRemarksDialogOpen$ | async"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '60vw', 'max-width': '900px' }"
    (visibleChange)="$event === false && store.dispatch(DispatchCalendarRemarksDialogActions.dialogClosed())"
  >
    <ng-template pTemplate="headless">
      <app-dispatch-calendar-remarks-dialog></app-dispatch-calendar-remarks-dialog>
    </ng-template>
  </p-dialog>

  <!-- Reusable template for dropdown items -->
  <ng-template
    #dropdownItemTemplate
    let-item
    let-labelPrefix="labelPrefix"
  >
    <div class="flex align-items-center gap-2">
      <i
        class="pi p-mr-2"
        [ngClass]="item.icon"
      ></i>
      <div class="p-text-capitalize">{{ labelPrefix }} {{ item.label }}</div>
    </div>
  </ng-template>

  <!--
    Assign Crew AI dialog. Unclosable while the optimizer runs; when no feasible
    schedule exists it stays open, becomes closable, and lists every reason so
    the dispatcher can fix availability or requirements and try again.
  -->
  <ng-container *ngIf="assignCrewInfeasibilityReasons$ | async as infeasibilityReasons; else assignCrewLoadingDialog">
    <p-dialog
      [modal]="true"
      [visible]="isAssignCrewDialogOpen$ | async"
      [closable]="true"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '480px' }"
      header="Could not assign crew"
      appendTo="body"
      (visibleChange)="$event || dismissAssignCrewResult()"
    >
      <div class="assign-crew-infeasible">
        <p class="infeasible-intro">
          <i class="pi pi-exclamation-triangle"></i>
          No schedule satisfies every constraint. Fix the items below, then try again.
        </p>
        <ul class="infeasible-reasons">
          <li *ngFor="let reason of infeasibilityReasons">{{ reason }}</li>
        </ul>
      </div>
      <ng-template pTemplate="footer">
        <p-button
          label="Close"
          [text]="true"
          (onClick)="dismissAssignCrewResult()"
        ></p-button>
        <p-button
          label="Try again"
          icon="pi pi-sparkles"
          (onClick)="assignCrewWithAI()"
        ></p-button>
      </ng-template>
    </p-dialog>
  </ng-container>
  <ng-template #assignCrewLoadingDialog>
    <p-dialog
      [modal]="true"
      [visible]="assigningCrewWithAI$ | async"
      [closable]="false"
      [draggable]="false"
      [resizable]="false"
      [style]="{ width: '400px' }"
      header="Assigning Crew"
      appendTo="body"
    >
      <div class="assign-crew-loading">
        <p-progressBar
          [value]="assignCrewProgress"
          [showValue]="false"
          [style]="{ height: '8px' }"
        ></p-progressBar>
        <p class="loading-text">
          {{ assignCrewProgressText }}
        </p>
        <p class="loading-subtext" *ngIf="assignCrewProgress < 100">
          Optimizing routes and assigning crew to {{ eventCountForAssign }} events...
        </p>
        <p class="loading-subtext" *ngIf="assignCrewProgress >= 100">
          Applying assignments...
        </p>
      </div>
    </p-dialog>
  </ng-template>
</div>
